import React from 'react'
import { useFormContext } from 'react-hook-form'

import { Text } from '@wartek-id/text-v1'

import { CardSummaryPraktikKinerja } from 'app/KinerjaPSPegawaiPage/components/CardSummaryPraktikKinerja'

import type {
  TPraktikKinerjaItem,
  TSatuanPendidikanV2Item,
} from 'types/kinerja-ps-pegawai'

type CekRangkumanProps = {
  praktikKinerjaData?: TPraktikKinerjaItem[]
  satuanPendidikanData: TSatuanPendidikanV2Item[]
}

const CekRangkuman = ({
  satuanPendidikanData,
  praktikKinerjaData = [],
}: CekRangkumanProps) => {
  const { watch } = useFormContext()
  const selectedPraktikKinerjaIds = watch('selectedPraktikKinerjaIds')
  const selectedSatuanPendidikanIds = watch('selectedSatuanPendidikanIds')

  const selectedPraktikKinerja = praktikKinerjaData.filter(({ id }) =>
    selectedPraktikKinerjaIds.includes(id)
  )
  const selectedSatuanPendidikan = satuanPendidikanData.filter(({ npsn }) =>
    (selectedSatuanPendidikanIds ?? []).includes(npsn)
  )

  return (
    <div className="space-y-6">
      <Text variant="heading-lg">Berikut Perencanaan Anda:</Text>

      <div className="grid grid-cols-2 gap-x-4">
        <CardSummaryPraktikKinerja title="Praktik Kinerja Anda:">
          <div className="flex flex-col items-start justify-between h-full px-6 py-4 space-y-6">
            {selectedPraktikKinerja?.map((pk, index) => (
              <div key={index} className="space-y-2">
                <Text data-testid="praktik-kinerja-name" variant="heading-sm">
                  {pk.nama}
                </Text>
                <Text key={index} color="subdued">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: (pk.keterangan ?? '').replace(/\\n/g, '<br />'),
                    }}
                  />
                </Text>
              </div>
            ))}
          </div>
        </CardSummaryPraktikKinerja>

        <CardSummaryPraktikKinerja title="Untuk difokuskan di satdik:">
          <div className="flex flex-col items-start justify-between h-full px-6 py-4 space-y-6">
            <div>
              <ol className="pl-6 list-disc">
                {selectedSatuanPendidikan.map(({ name }, index) => (
                  <li key={index}>
                    <Text color="subdued">{name}</Text>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </CardSummaryPraktikKinerja>
      </div>
    </div>
  )
}

export default CekRangkuman
